import { CimClass } from "./network-structure.model";
import { BaseFilter } from "./cim-substation.model";

export class ConnectorSwitchViewModel {
    id!: number;
    name!: string;
    equipmentType!: string;
    substationId!: number;
    parentClass!: string;
    parentName!: string;
    baseVoltage!: string;
    baseVoltageId: number | null;

    constructor(data?: any) {
        this.baseVoltageId = data?.baseVoltage.id ?? null;
    }
}

export class EditConnectorSwitchDto {
    id: number | null;
    equipmentType: string;
    baseVoltageId: number | null;
    name: string;
    equipmentContainerId: number;
    substationTemplateInstanceId: number | null;
    parentClass: string;
    parentName: string;
    destinationEquipment: Array<EquipmentSourceDestination> | null;
    sourceEquipment: Array<EquipmentSourceDestination> | null;
    destinationEquipmentIds: Array<number> = [];
    sourceEquipmentIds: Array<number> = [];

    constructor (obj: any = null) {
        this.id = obj?.id ?? null;
        this.equipmentType = obj?.equipmentType ?? '';
        this.baseVoltageId = obj?.baseVoltage?.id ?? null;
        this.name = obj?.name ?? '';
        this.equipmentContainerId = obj?.equipmentContainerId ?? null;
        this.substationTemplateInstanceId = obj?.substationTemplateInstanceId ?? null;
        this.parentClass = obj?.parentClass ?? '';
        this.parentName = obj?.parentName ?? '';
        this.destinationEquipment = obj?.destinationEquipment ?? [];
        this.sourceEquipment = obj?.sourceEquipment ?? [];
        this.destinationEquipmentIds = this.destinationEquipment?.map(x => x.id) ?? [];
        this.sourceEquipmentIds = this.sourceEquipment?.map(x => x.id) ?? [];
    }
}
export class EquipmentSourceDestination {
    id: number = 0;
    name: string = '';
    hasSource: boolean = false;
    hasDestination: boolean = false;
    equipmentType?: CimClass;
}

export class ConnectorSwitchFilter extends BaseFilter {
    searchType: ConnectorSwitchSearchType = ConnectorSwitchSearchType.Name;
    substationTemplateIds: number[] = [];
    baseVoltageIds: number[] = [];
}

export enum ConnectorSwitchSearchType {
    Name = 1,
    SubstationName = 2
}
